"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NODE_MAX_W_FACTOR = exports.BLOCK_LABEL_PAD_X = exports.TEXT_CHAR_W_PER_SIZE = exports.BOARD_LABEL_FONT_SIZE = exports.CHIP_FONT_SIZE = exports.SUB_FONT_SIZE_BIG = exports.SUB_FONT_SIZE = exports.NAME_FONT_SIZE_BIG = exports.NAME_FONT_SIZE = exports.EM_TO_CAP = exports.BOARD_OUTLINE_STROKE_W = exports.PROCESSOR_STROKE_W = exports.BLOCK_STROKE_W = exports.ARROW_HALF_W = exports.ARROW_LEN = exports.EDGE_STYLE = exports.CHIP_DEOVERLAP_DY = exports.CHIP_H = exports.CHIP_PAD_W = exports.CHIP_CHAR_W = exports.CORRIDOR_LANE_PAD = exports.GUTTER_LANE_PAD = exports.CORRIDOR_LANE_STEP = exports.GUTTER_EXTRA = exports.GUTTER_MIN = exports.BOARD_PAD = exports.MARGIN = exports.LANE_STEP = exports.GAP_Y = exports.NODE_H = exports.NODE_W = void 0;
exports.estimateTextWidth = estimateTextWidth;
exports.truncateTextToWidth = truncateTextToWidth;
exports.NODE_W = 180;
exports.NODE_H = 56;
exports.GAP_Y = 48;
exports.LANE_STEP = 13;
exports.MARGIN = 40;
exports.BOARD_PAD = 24;
exports.GUTTER_MIN = 120;
exports.GUTTER_EXTRA = 80;
exports.CORRIDOR_LANE_STEP = 12;
exports.GUTTER_LANE_PAD = 8;
exports.CORRIDOR_LANE_PAD = 10;
exports.CHIP_CHAR_W = 5.6;
exports.CHIP_PAD_W = 10;
exports.CHIP_H = 17;
exports.CHIP_DEOVERLAP_DY = 18;
exports.EDGE_STYLE = {
    rail: { width: 3, lineStyle: 'solid' },
    bus: { width: 2, lineStyle: 'solid' },
    control: { width: 1.5, lineStyle: 'dash' },
    analog: { width: 1.5, lineStyle: 'dot' },
};
exports.ARROW_LEN = 9;
exports.ARROW_HALF_W = 4;
exports.BLOCK_STROKE_W = 1.3;
exports.PROCESSOR_STROKE_W = 2.5;
exports.BOARD_OUTLINE_STROKE_W = 1.5;
exports.EM_TO_CAP = 0.7;
exports.NAME_FONT_SIZE = 12 * exports.EM_TO_CAP;
exports.NAME_FONT_SIZE_BIG = 14.5 * exports.EM_TO_CAP;
exports.SUB_FONT_SIZE = 9.5 * exports.EM_TO_CAP;
exports.SUB_FONT_SIZE_BIG = 10.5 * exports.EM_TO_CAP;
exports.CHIP_FONT_SIZE = 9.5 * exports.EM_TO_CAP;
exports.BOARD_LABEL_FONT_SIZE = 10 * exports.EM_TO_CAP;
exports.TEXT_CHAR_W_PER_SIZE = 0.6 / exports.EM_TO_CAP;
exports.BLOCK_LABEL_PAD_X = 10;
exports.NODE_MAX_W_FACTOR = 1.5;
function estimateTextWidth(value, size) {
    return value.length * size * exports.TEXT_CHAR_W_PER_SIZE;
}
function truncateTextToWidth(value, size, maxWidth) {
    if (estimateTextWidth(value, size) <= maxWidth) {
        return value;
    }
    const maxChars = Math.floor(maxWidth / (size * exports.TEXT_CHAR_W_PER_SIZE));
    return value.slice(0, Math.max(maxChars - 1, 1)) + '…';
}
//# sourceMappingURL=constants.js.map